'use client';

import { useEffect, useState } from 'react';
import { createSpring, type Spring, type SpringOptions } from './spring';

/**
 * One spring for the lifetime of the component, destroyed with it.
 *
 * Returns the instance rather than a value on purpose: the point of the JS
 * spring is that a frame never re-renders React (see spring.ts). Callers
 * subscribe with `onChange` in an effect and write to a ref'd node.
 */
export function useSpring(initial: number, options?: SpringOptions): Spring {
  // Lazy state, not a ref: created once, during the first render, and never
  // re-created — `options` is read on that first render only.
  const [spring] = useState(() => createSpring(initial, options));
  useEffect(() => () => spring.destroy(), [spring]);
  return spring;
}
